<template>
  <div class="settings-table">
    <div class="title">
      <h5>
        Users&nbsp;<span v-if="total">({{total}})</span>
      </h5>
      <button class="primary-btn" v-if="manageAccess" @click="createUser">
        <i class="fa fa-plus" />
        Add User
      </button>
    </div>

    <div class="table-head" v-if="isDesktop()">
      <p class="d-left">Name</p>
      <p class="d-left">Email</p>
      <p class="d-right">Role</p>
      <p>Verified</p>
      <p>Status</p>
    </div>
    <div class="table-body">
      <div class="table-row" v-for="(user, index) in usersList" :key="index"
          @click="showUserDetails(user.id)">
        <p class="d-left">
          <b v-if="!isDesktop()">Name:</b>
          {{user.name || 'Hypto Admin'}}
        </p>
        <p class="d-left break">{{user.email}}</p>
        <p class="d-right">
          <b v-if="!isDesktop()">Role:</b>
          {{user.role}}
        </p>
        <p>
          <b v-if="!isDesktop()">Verified:</b>
          <i class="fa" :class="{'fa-check': user.verified, 'fa-times': !user.verified}" />
        </p>
        <p class="mt-grey-text">{{user.status}}</p>
      </div>
    </div>

    <table-loader v-if="!total" :css="{'border-layout': !isDesktop()}" />
  </div>
</template>

<script>
import TableLoader from '@/components/global/TableLoader'

import ApiServices from '@/services/api/users'

export default {
  name: 'UsersList',
  components: { TableLoader },
  data () {
    return {
      total: null,
      usersList: [],
      manageAccess: false
    }
  },
  created () {
    this.populateData()
  },
  methods: {
    populateData () {
      ApiServices.usersList().then(response => {
        let data = response.data
        if (data) {
          this.usersList = data.users
          this.total = data.total
          this.manageAccess = response.privileges.manage_users
        }
      })
    },
    showUserDetails (id) {
      this.$router.push({name: 'UserDetails', params: {id}})
    },
    createUser () {
      this.$router.push({name: 'UserCreate'})
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/settingsTable.scss';

  .table-row {
    .fa-check {
      color: $increase;
    }
    .fa-times {
      color: $decrease;
    }
  }

  .break {
    word-break: break-all;
  }

  .desktop {
    .table-head, .table-row {
      grid-template-columns: 20% 30% 20% 12% 12% !important;
    }
  }

  .tablet, .mobile {
    .table-row {
      grid-template-areas: "email email"
                            "name role"
                            "verified status";

      p {
        &:nth-child(1) {
          grid-area: name;
        }
        &:nth-child(2) {
          grid-area: email;
          color: $primary;
        }
        &:nth-child(3) {
          grid-area: role;
          text-align: right;
        }
        &:nth-child(4) {
          grid-area: verified;
        }
        &:nth-child(5) {
          grid-area: status;
          text-align: right;
        }

        .fa-check, .fa-times {
          margin-left: 5px;
        }
      }
    }
  }
</style>
